import $ from "jquery";

class ToolbarItem {

    constructor() {
        this.disabled = false;
        this.active = false;
        this.icon = '';
    }

    setIcon(icon) {
        this.icon = icon;
    }

    /**
     * @abstract
     */
    getText() {
        throw new Error('You must override the getText method');
    }

    handleClick() {
        console.error("No click handler, %s", this.getText());
    }

    getHref() {
        return '#';
    }

    getIconUrl() {
        let icon = {
            module: "toolbar",
            icon: '',
        };
        if ('object' === typeof this.icon) {
            icon = $.extend(icon, this.icon);
        } else {
            icon.icon = this.icon;
        }
        return window.CONFIG.adminBuildUrl + '' + icon.module + '/icons.svg#' + icon.icon;
    }

    getElement() {
        const $elem = eotwJSXFactory('a', {className: "admin-toolbar__item", tabIndex: "-1", href: this.getHref()});

        if (this.icon !== '') {
            $elem.html('<span class="admin-toolbar__icon"><svg><use xlink:href="' + this.getIconUrl() + '"></use></svg></span>');
        }

        $elem.append($("<span>").addClass("admin-toolbar__text").text(this.getText())).on("click", (e) => {
            if (this.disabled) return false;
            try {
                return this.handleClick(e) === true;
            } catch (e) {
                console.error(e);
            }
        });
        if (this.disabled) {
            $elem.addClass("disabled").attr("disabled", true);
        }
        if (this.active) {
            $elem.addClass("admin-toolbar__item--active");
        }

        return $elem;
    }

    setDisabled(disabled) {
        this.disabled = disabled;
    }

}

export default ToolbarItem;
